import { Helmet } from './Helmet';

interface HelmetTitleProps {
  title?: string;
  message?: string;
}

export const HelmetTitle: React.FC<HelmetTitleProps> = ({
  title = 'Nonograms Online',
  message,
}) => {
  return (
    <Helmet
      title={`${title}${message ? ` - ${message}` : ''}`}
    />
  );
};
